import type { FC } from 'react';

import { IconButtonWithTooltip, Icons, TooltipPositions } from '../../../controls/iconButton/IconButtonWithTooltip';

interface HelpControlPlainProps {
  condition: boolean;
  onClick: () => void;
}

export const HelpControlPlain: FC<HelpControlPlainProps> = ({ condition, onClick }) => {
  return (
    <IconButtonWithTooltip
      data-testid="help-button"
      icon={Icons.Help}
      active={condition}
      onClick={onClick}
      tooltipOptions={{
        text: 'HELP',
        position: TooltipPositions.Bottom,
      }}
    />
  );
};
